import { render } from "./EstoCreditWidget.vue?vue&type=template&id=1311aa06"
const script = {}

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__